<template>
  <form class="form">
    <div class="form_row">
      <div class="group">
        <input
          name="name"
          v-model="name"
          type="text"
          placeholder="Jon Doe"
          required
        />
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>Name *</label>
      </div>

      <div class="group">
        <input
          name="email"
          v-model="email"
          type="email"
          placeholder="JonDoe@gmail.com"
          required
        />
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>Email *</label>
      </div>
    </div>

    <div class="form_row">
      <div class="group">
        <input
          name="phone"
          v-model="phone"
          type="tel"
          placeholder="+35296141665"
          required
        />
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>Tel. *</label>
      </div>

      <div class="group">
        <input
          name="companyName"
          v-model="companyName"
          type="text"
          placeholder="Jon Doe LLC."
        />
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>Company</label>
      </div>
    </div>

    <div class="form_row">
      <div class="group w-100">
        <input
          name="message"
          v-model="message"
          type="text"
          placeholder="..."
          required
        />
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>Message</label>
      </div>
    </div>

    <div class="form_action">
      <button class="form_submit" @click.prevent="sentForm">
        Send message
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: "AppForm",
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      companyName: "",
      message: ""
    };
  },
  methods: {
    sentForm() {
      const { name, email, phone, companyName, message } = this;
      const body = new FormData();
      body.append("name", name);
      body.append("email", email);
      body.append("phone", phone);
      body.append("companyName", companyName);
      body.append("message", message);

      let options = {
        method: "POST",
        body: body
      };
      fetch("./mail.php", options);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/function.scss";
@import "@/assets/breackpoints.scss";

.form {
  &_row {
    display: flex;
    justify-content: space-between;

    &:not(:last-of-type) {
      margin-bottom: 35px;
    }
  }

  &_action {
    display: flex;
    justify-content: flex-end;
  }

  &_submit {
    position: relative;
    padding: 0 vw(35px);
    height: 45px;
    display: flex;
    align-items: center;
    color: #0e9244;
    background-color: rgba(#ffffff, 0.75);
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 700;
    z-index: 1;

    @media (max-width: $md) {
      padding: 0 20px;
    }

    &:hover {
      &::before {
        width: 100%;
      }
    }

    &:active {
      &::before {
        background-color: rgba(#ffffff, 1);
      }
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background-color: rgba(#ffffff, 0.5);
      transition: all 0.25s ease;
      z-index: -1;
    }
  }
}

.group {
  position: relative;
  width: 45%;

  &.w-100 {
    width: 100%;
  }
}

input {
  font-size: 16px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  color: #ffffff;
  border-radius: 0 !important;
  background-color: transparent;
  border-bottom: 1px solid rgba(#ffffff, 0.5);

  &::placeholder {
    opacity: 0;
  }
}

input:focus {
  outline: none;
}

label {
  color: #a4aeb0;
  font-size: 16px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 0px;
  top: 10px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
/* active state */
input:not(:placeholder-shown) ~ label,
input:focus ~ label {
  top: -10px;
  font-size: 12px;
  color: #ffffff;
}
.bar {
  position: relative;
  display: block;
  width: 100%;
}
.bar:before,
.bar:after {
  content: "";
  height: 2px;
  width: 0;
  bottom: 0px;
  position: absolute;
  background: #ffffff;
  transition: 0.2s ease all;
}
.bar:before {
  left: 50%;
}
.bar:after {
  right: 50%;
}
input:focus ~ .bar:before,
input:focus ~ .bar:after {
  width: 50%;
}
</style>
